// A section-library template lands as a COPY: one AddElementTree of a plain deep copy of the
// template's tree (already in that event's shape), so every element is the page's own and
// nothing references the library afterwards.
export const LIBRARY_DRAG_TYPE = "library-section";

function collectElementTypes(node, types) {
  types.add(node.elementType);
  for (const child of node.children ?? []) {
    collectElementTypes(child, types);
  }
  return types;
}

export function libraryTreeForInsert(tree) {
  if (!tree || typeof tree.elementType !== "string") {
    throw new Error(`section-library-drop: a library tree needs an elementType at its root, got ${JSON.stringify(tree)?.slice(0, 200)}`);
  }
  const copy = JSON.parse(JSON.stringify(tree));
  return { tree: copy, elementTypes: [...collectElementTypes(copy, new Set())] };
}

// What a palette row puts on the drag: only the key. The tree is fetched when it lands,
// so a drag never races a download.
export function libraryDragPayload(section) {
  return {
    kind: LIBRARY_DRAG_TYPE,
    variantKey: section.variantKey,
    displayName: section.name,
    sectionType: section.sectionType,
  };
}
